//BestManAndMaids.js

import React from 'react';
import { cx, useRuntimeCss } from '../shared/styles/runtimeCss';

const getResponsiveValue = (mobileValue, tabletValue, desktopValue) => {
  if (window.innerWidth <= 480) return mobileValue;
  if (window.innerWidth <= 768) return tabletValue;

  return desktopValue;
};

const buildSectionStyles = (theme) => ({
  maxWidth: '1200px',
  margin: '0 auto',
  padding: getResponsiveValue('3rem 1rem', '4rem 1.5rem', '5rem 2rem'),
  backgroundColor: theme?.colors?.background || '#ffffff',
  borderRadius: theme?.borderRadius?.medium || '8px',
  textAlign: 'center',
});

const buildTitleStyles = (theme) => ({
  fontSize: getResponsiveValue('2rem', '2.5rem', '32px'),
  fontFamily: theme?.fonts?.heading || "'Montserrat', sans-serif",
  color: theme?.colors?.primary || '#4E7C7F',
  marginBottom: '1rem',
  fontWeight: 300,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
});

const buildDescriptionStyles = (theme) => ({
  fontSize: getResponsiveValue('1rem', '1.1rem', '1.2rem'),
  fontFamily: theme?.fonts?.body || "'Open Sans', sans-serif",
  color: theme?.colors?.text || '#1E293B',
  lineHeight: '1.6',
  maxWidth: '800px',
  margin: '0 auto 2rem',
});

const buildGridStyles = () => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  gap: getResponsiveValue('1rem', '1.5rem', '2rem'),
  maxWidth: '800px',
  margin: '0 auto',
});

const buildPhotoCardStyles = (theme, hasPhoto) => ({
  width: getResponsiveValue('280px', '300px', '250px'),
  height: getResponsiveValue('280px', '300px', '250px'),
  borderRadius: theme?.borderRadius?.medium || '8px',
  overflow: 'hidden',
  boxShadow: theme?.shadows?.small || '0 4px 8px rgba(0,0,0,0.1)',
  position: 'relative',
  backgroundColor: hasPhoto ? 'transparent' : theme?.colors?.secondary || '#F1F5F9',
  flexShrink: 0,
});

const buildPhotoImageStyles = () => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const buildPhotoPlaceholderStyles = (theme) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme?.colors?.text || '#1E293B',
  fontSize: getResponsiveValue('0.9rem', '1rem', '1.1rem'),
  fontFamily: theme?.fonts?.body || "'Open Sans', sans-serif",
  textAlign: 'center',
  padding: '1rem',
});

const BestMenAndMaids = ({ section, theme }) => {
  const css = useRuntimeCss();

  const { title, description, photoCount, photos } = section.props;

  // Ensure photos is an array and pad with empty strings if needed
  const photoArray = Array.isArray(photos) ? photos : [];
  const displayPhotos = [...photoArray, ...Array(Math.max(0, photoCount - photoArray.length)).fill('')];

  return (
    <div className={cx('best-men-maids-section', css(buildSectionStyles(theme)))}>
      <h2 className={css(buildTitleStyles(theme))}>
        {title || 'Нашите Кумове'}
      </h2>
      <p className={css(buildDescriptionStyles(theme))}>
        {description || 'Запознайте се с нашите кумове, които ще ни съпътстват в този специален ден.'}
      </p>
      <div className={css(buildGridStyles())}>
        {displayPhotos.slice(0, photoCount).map((photo, index) => (
          <div
            key={index}
            className={css(buildPhotoCardStyles(theme, Boolean(photo)))}
          >
            {photo ? (
              <img
                src={photo}
                alt={`Кум/Кума ${index + 1}`}
                className={css(buildPhotoImageStyles())}
              />
            ) : (
              <div className={css(buildPhotoPlaceholderStyles(theme))}>
                Няма изображение
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BestMenAndMaids;
